<template>
    <Container v-if="showSection">
        <SectionHeader :title="title" :description="description" />
        <InfiniteScroll :once="true" @isvisible="loadData" v-if="loading">
            <div class="list">
                <div
                    class="item preLoaderPlaceholder"
                    v-for="i in 6"
                    :key="i"
                ></div>
            </div>
        </InfiniteScroll>
        <div class="list" v-else>
            <Item v-for="item in blogs" :key="item.id" :data="item" />
        </div>
    </Container>
</template>
<script>
import Item from "./item.vue";
export default {
    props: {
        title: {
            type: String,
            default: "WisdomPearls",
        },
        description: {
            type: String,
            default:
                "Throughout history, stories have been the vessels through which wisdom is passed down from generation to generation. They have the ability to transcend time and space, connecting us to the experiences, emotions, and insights of others. Whether it's a fable from ancient folklore or a modern-day anecdote, every story has the potential to leave an indelible mark on our lives. WisdomPearl series is a short story with a life lesson to ponder and reflect upon.",
        },
        excluedIds: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        Item,
    },
    data() {
        return {
            blogs: [],
            loading: true,
            showSection: true,
        };
    },
    methods: {
        loadData() {
            const exclude = this.excluedIds.join(",");

            axios
                .get(this.$route("home.blogs.api"), {
                    params: {
                        exclude,
                    },
                })
                .then(({ data }) => {
                    this.blogs = data.data || [];

                    setTimeout(() => {
                        this.loading = false;

                        this.showSection = this.blogs.length > 0;
                    }, 100);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 1.4rem;

    .item.preLoaderPlaceholder {
        height: 300px;
        margin: 0;
        border-radius: var(--border-radius);
        box-shadow: var(--box-shadow);
    }
}
</style>
